<template>
  <Secao titulo="programação" id="programacao">
      <b-modal
      id="modal-1"
      size="lg"
      v-model="exibirModal"
      :title="atividade.nome"
      centered
      v-if="atividade"
    >
      <p v-if="atividade.pessoa">com {{ atividade.pessoa }}</p>
      <p class="my-4">{{ atividade.descricao }}</p>
      <template slot="modal-footer">      
        <div class="float-right">
          <button @click="exibirModal = !exibirModal" class="btn btn-warning">
            Fechar
          </button>
        </div>
      </template>
    </b-modal>

    <div class="row">
      <div class="col-md-3">
        <img
          src="@/assets/imgs/layout/programacao.png"
          alt="Ilustração de pessoa usando celular"
          class="img-fluid"
        />
        <h4>
          <span class="destaque"
            >Anote na agenda, configure o despertador:</span
          >
          uma programação dessas não dá pra perder!
        </h4>
      </div>
      <div class="col-md-8 offset-md-1">
        <h5 class="mb-5">Programação por dia</h5>

        <div
          class="accordion"
          role="tablist"
          v-for="dia in datas"
          :key="dia.id"
        >
          <b-card no-body class="mb-1">
            <b-card-header
              header-tag="header"
              v-b-toggle="`accordion-${dia.dia}`"
              class="p-3 d-flex justify-content-between align-items-center"
              role="tab"
            >
              <div>
                <i class="lni lni-calendar"></i> {{ dia.dia
                }}<span class="laranja">JUN</span> | {{ dia.nome }}
              </div>
              <div><i class="lni lni-chevron-down"></i></div>
            </b-card-header>
            <b-collapse
              visible
              :id="`accordion-${dia.dia}`"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-list-group>
                  <b-list-group-item
                    v-for="item in filtrarEventosPorDia(dia.dia)"
                    @click="exibir(item)"
                    :key="item.id"
                    ><span class="laranja"
                      ><i class="lni lni-alarm-clock"></i>
                      {{ item.horarioInicio }} às {{ item.horarioFim }}</span
                    >
                    {{ item.nome }}</b-list-group-item
                  >
                </b-list-group>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </div>
  </Secao>
</template>

<script>
import Secao from "../layout/Secao.vue";
import PROGRAMACAO from "@/assets/dados/palestrantes2.json";
//import axios from "axios";

export default {
  name: "App",
  components: {
    Secao,
  },

  data() {
    return {
      exibirModal: false,
      atividade: null,
      programacao: PROGRAMACAO,
      datas: [
        {
          dia: 1,
          nome: "Quarta-feira",
        },
        {
          dia: 2,
          nome: "Quinta-feira",
        },
        {
          dia: 3,
          nome: "Sexta-feira",
        },
        {
          dia: 4,
          nome: "Sábado",
        },
      ],
    };
  },

  created(){
    /*axios
    .get('https://enati-ifgoiano.github.io/dados/programacao.json')
    .then((response) => {
        this.programacao = response.data;
    })*/
  },

  methods: {
    exibir(atividade) {
      if(atividade.descricao){
      this.atividade = atividade;
      this.exibirModal = true;
      }
    },
    filtrarEventosPorDia(dia) {
      return this.programacao.filter((x) => {
        return x.dia == dia ? x : false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
section#programacao {
  background: var(--begeCor);
  background-image: radial-gradient(
    circle at 25% 50%,
    var(--bege),
    transparent 45%
  );
  .card {
    margin: 10px 0px;
    &:hover {
      cursor: pointer;
    }
  }
}

.foto-palestrante-modal{
	max-width: 300px;
	float: left;
	border-radius: 20px;
	margin-right: 1rem;
}
</style>
